import * as Sentry from '@sentry/vue';
import Vue from 'vue';

if (process.env.VUE_APP_SENTRY_DSN && (process.env.DEPLOY_ENVIRONMENT !== 'LOCAL' && process.env.DEPLOY_ENVIRONMENT !== 'DEV')) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.DEPLOY_ENVIRONMENT,
    serverName: process.env.APP_LOCATION || 'Unknown',
    release: process.env.APP_VERSION || 'TRUNK',
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      // Vue errors
      'TypeError: Failed to fetch',
      'TypeError: NetworkError when attempting to fetch resource.',
      'Notification already in queue',
      'Redirected when going from "/login" to "/" via a navigation guard.',
      /ChunkLoadError/,
      /Loading CSS chunk.*/,
      /Loading chunk.*/,
      /SyntaxError: Unexpected token.*/,
      /Error: Network Error.*/,
      /containerRef\.scrollTo.*/,
      /instantSearchSDKJSBridgeClearHighlight.*/,
      /Redirected when going from.*/,
      /Navigation cancelled from.*/,
      /Navigation aborted.*/,
      /Navigating to current location.*/,
      /Avoided redundant navigation.*/,
      /NavigationDuplicated.*/,
    ],
    denyUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
    sampleRate: 1.0
  });
}
export { Sentry };
